// extracted by mini-css-extract-plugin
export var statItem = "_ld-1";
export var statsRow = "_ld-0";